import React from 'react';
import {
  DropdownMenu,
  DropdownToggle,
  Table,
  UncontrolledDropdown,
  DropdownItem
} from 'reactstrap';

import SortableTh from '@components/SortableTh/SortableTh';

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh {...props} label={'Email'} field={'email'} />
          <SortableTh {...props} label={'Name'} field={'name'} />
          <SortableTh {...props} label={'Role'} field={'role'} />
          <SortableTh {...props} label={'Status'} field={'email'} />
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          return (
            <tr key={item.id}>
              <td>{item.email}</td>
              <td>{item.name}</td>
              <td>{item.role}</td>
              <td>{item.status ? 'Active' : 'Inactive'}</td>
              <td>
                <UncontrolledDropdown>
                  <DropdownToggle caret className={'btn-xs'}>
                    Actions
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={() => props.onEntityClick(item)}>
                      Edit Details
                    </DropdownItem>
                    <DropdownItem onClick={() => props.onChangePassword(item)}>
                      Reset Password
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
